import type { ButtonRadiusSelectorType } from ".";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { BUTTON_RADIUS_SELECTOR_TYPES } from "./constants";

interface SelectorProps {
  selectedRadius: ButtonRadiusSelectorType;
  setSelectedRadius: (radius: ButtonRadiusSelectorType) => void;
}

export const Selector = ({
  selectedRadius,
  setSelectedRadius,
}: SelectorProps) => (
  <div className="bg-tertiary flex items-center justify-start gap-px rounded-xl p-1">
    {BUTTON_RADIUS_SELECTOR_TYPES.map(button => (
      <button
        key={button.type}
        type="button"
        className={classNames(
          "flex items-center justify-center rounded-lg p-1.5",
          {
            "bg-primary": selectedRadius === button.type,
            "bg-transparent": selectedRadius !== button.type,
          },
        )}
        onClick={() => setSelectedRadius(button.type)}
      >
        <Icon type={button.icon} size={20} />
      </button>
    ))}
  </div>
);
